import React, { ChangeEvent, DetailedHTMLProps } from "react";
import { TextInputProps } from "../../Default/TextInput";

export default function TextInput({
    value,
    label,
    className,
    placeholder,
    onChange,
    error = false,
    multiline = false,
    maxLength,
    readonly = false,
    disabled = false,
    color = "gray-100",
    borderColor,
    name
}: TextInputProps) {
    const labelClassName = error
        ? "inline-block text-base font-bold mb-1 text-red-500 uppercase"
        : "inline-block text-base font-bold mb-1 uppercase";

    let inputClassName = `p-2 px-4 text-lg border bg-${color} w-full rounded`;
    inputClassName += error ? " border-red-500" : ` border-${borderColor||color}`;

    const InputComponent = multiline ? "textarea" : "input";

    if(disabled){
        inputClassName = inputClassName + " opacity-75";
    }

    return (
        <div className={className}>
            <label className={labelClassName}>{label}</label>
            <InputComponent
                value={value}
                onChange={onChange}
                type="text"
                maxLength={maxLength}
                placeholder={placeholder}
                className={inputClassName}
                readOnly={readonly}
                name={name}
                disabled={disabled}
            />
        </div>
    );
}
